import { gql } from '@apollo/client';
import { client as apolloClient } from '@xbcb/apollo-client';

const GENERATE_JWT = gql`
  query GenerateJWT {
    generateJWT
  }
`;

/**
 * Generates a Connect Pro JWT token for the currently authenticated operator.
 * The server derives the operator's login from the authenticated session context.
 */
export const getConnectProToken = async (): Promise<string> => {
  try {
    const { data } = await apolloClient.query({
      query: GENERATE_JWT,
    });
    return data?.generateJWT || '';
  } catch (error) {
    console.error('Failed to generate JWT token:', error);
    return '';
  }
};
